import { localStorage } from '@/utils/env'

// It's important to store these in a separate file because input-phone.tsx is "expensive" to load
// due to libphonenumber, and these constants are used in the shared chunks
export const INPUT_PHONE_KEY = 'user/phone'
export const INPUT_PHONE_STORAGE = localStorage
